"use client";

import footer from "@/constants/footer.constant";
import Link from "next/link";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function Seo() {
  const matches = useMediaQuery("(min-width:1024px)");

  const content = (
    <div className="max-w-8xl mx-auto px-4 py-4 md:py-8">
      <div className="prose max-w-full text-xs text-zinc-900">
        <div className="mb-6 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
          {footer.map((value, index) => (
            <div key={index} className="mb-4">
              <h5 className="mb-2">
                <strong>{value.title}</strong>
              </h5>
              <div className="space-y-1.5">
                {value.nodes.map((val, i) => (
                  <div key={`${index}-${i}`}>
                    <span className="uppercase tracking-wider">
                      {val.title}:
                    </span>
                    <span className="divide-x">
                      {val.nodes.map((v, k) => (
                        <Link
                          key={`${index}-${i}-${k}`}
                          href={v.url}
                          title={v.title}
                          className="px-2 no-underline hover:underline text-zinc-900"
                        >
                          {v.title}
                        </Link>
                      ))}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <h5>
          <strong>About eVerse Stores</strong>
        </h5>
        <p>
          eVerse Stores is a trusted name in robotics and drone solutions in
          India, delivering advanced technology for industry, education, and
          enterprise applications. We specialise in quadruped robots, humanoid
          robots, companion robots, and utility robots, along with a complete
          range of professional drone services. Our focus is on providing
          reliable, practical, and future-ready solutions that help
          organisations work smarter, safer, and more efficiently. We partner
          with global brands and certified Indian manufacturers to ensure high
          performance, quality assurance, and long-term reliability across all
          our products and services.
        </p>
        <h5>
          <strong>Robotics Solutions</strong>
        </h5>
        <p>
          At eVerse Stores, we offer a wide range of intelligent robotics
          solutions designed for real-world use cases such as inspection,
          surveillance, automation, training, and research. Our quadruped robots
          like the Unitree Go2 deliver exceptional mobility and AI-driven
          performance in challenging environments. Our humanoid and companion
          robots combine smart interaction with user-friendly design, making
          them ideal for education, demonstrations, and engagement. For
          businesses, our utility robots support logistics, security, and
          operational efficiency across sectors such as manufacturing,
          infrastructure, and agriculture.
        </p>
        <h5>
          <strong>Industries We Serve</strong>
        </h5>
        <p>
          Our solutions are used across multiple sectors including
          infrastructure, agriculture, manufacturing, mining, energy, smart
          cities, education, and public safety. By understanding
          industry-specific challenges, we deliver technology that solves real
          operational problems and supports better decision-making.
        </p>
        <h5>
          <strong>Drone Services</strong>
        </h5>
        <p>
          eVerse Stores is your complete partner for professional drone services
          across India. We provide drone surveillance for infrastructure,
          industrial sites, mining operations, and security monitoring. Our
          agriculture spraying services help optimise crop management through
          precise and efficient application of inputs. We also deliver drone
          shows for corporate events, festivals, and special occasions with
          synchronised aerial displays. To keep your UAVs performing at their
          best, we offer drone repair and maintenance services focused on
          safety, reliability, and long-term performance.
        </p>
        <h5>
          <strong>Buy, Sell & Training</strong>
        </h5>
        <p>
          We make it easy to buy, sell, and upgrade drones and robotics
          equipment. You can sell your used training drones, explore premium
          drones from leading brands such as DJI and Autel, and choose from a
          curated range of solutions for surveying, inspection, monitoring, and
          creative projects. We also provide drone pilot training programs to
          help beginners and professionals work towards DGCA certification with
          practical, industry-focused training.
        </p>
        <h5>
          <strong>Quality, Safety & Compliance</strong>
        </h5>
        <p>
          At eVerse Stores, we follow strict standards for quality control,
          safety, and compliance. Our services are delivered using tested
          equipment, genuine components, and professional workflows. We also
          ensure responsible drone operations aligned with applicable
          regulations and best practices.
        </p>
        <h5>
          <strong>Why Choose eVerse Stores</strong>
        </h5>
        <p>
          What sets eVerse Stores apart is our commitment to quality,
          transparency and customer satisfaction. We work with trusted
          technology partners, use genuine products and components, and follow
          professional service standards. Our team supports you from solution
          selection to after-sales service, ensuring smooth execution and
          dependable results for every project.
        </p>
        <h5>
          <strong>Our Commitment</strong>
        </h5>
        <p>
          At eVerse Stores, our mission is to empower businesses, institutions
          and innovators with reliable robotics and drone technology. Whether
          you need advanced robots, professional drone services, certified
          training, or dependable support, we are here to help you build
          smarter, safer, and more efficient operations. eVerse Stores Powering
          the future with robotics and drone technology.
        </p>
      </div>
    </div>
  );

  return (
    <>
      {matches ? (
        content
      ) : (
        <Accordion
          disableGutters
          elevation={0}
          sx={{
            "&:before": {
              display: "none",
            },
            boxShadow: "none",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography
              component="span"
              sx={{ fontSize: "0.9rem", fontWeight: 500 }}
              className="line-clamp-1"
            >
              eVerse Stores: Your Trusted Source for Premium Robotics and Drone
              Solutions
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 0 }}>{content}</AccordionDetails>
        </Accordion>
      )}
    </>
  );
}
